import { BotInfo, BrowserInfo, detect, NodeInfo } from 'detect-browser';
import Big from 'big.js';
import moment from 'moment';
import { IImportData, IImportOffer, MfaMethod } from 'types';
import isTesting from './isTesting';
import { MfaSetupSettingsType } from '../types';
import * as api from '../api/api';
import { getGlobalConfig } from './globalConfig';

export const isVersionSupported = (browserName: string, browserVersion: string): boolean => {
  const versionWithSingleDecimalArr = browserVersion ? browserVersion.split('.') : [];
  const versionWithSingleDecimal =
    versionWithSingleDecimalArr.length > 1
      ? `${versionWithSingleDecimalArr[0]}.${versionWithSingleDecimalArr[1]}`
      : `${versionWithSingleDecimalArr[0]}`;

  const version = new Big(versionWithSingleDecimal);

  // alert(
  // 	browserName +
  // 		browserVersion +
  // 		' big version: ' +
  // 		version +
  // 		' valid: ' +
  // 		version.gte(10.3)
  // );
  switch (browserName) {
    case 'edge': {
      return version.gte(16);
    }
    case 'edge-chromium': {
      return version.gte(79);
    }
    case 'samsung': {
      return version.gte(7);
    }
    case 'crios':
    case 'chrome': {
      return version.gte(57);
    }
    case 'firefox': {
      return version.gte(52);
    }
    case 'android': {
      return version.gte(67);
    }
    case 'ios': {
      return version.gte(10.3);
    }
    case 'safari': {
      return version.gte(10.1);
    }
    case 'opera': {
      return version.gte(44);
    }
  }
  return false;
};

export const isBrowserSupported = (): boolean => {
  const browser: BrowserInfo | BotInfo | NodeInfo | null = detect();
  const supportedBrowsers = [
    'edge',
    'edge-chromium',
    'samsung',
    'chrome',
    'firefox',
    'android',
    'ios',
    'crios',
    'safari',
    'opera'
  ];

  return browser
    ? supportedBrowsers.includes(browser.name) &&
        isVersionSupported(browser.name, browser.version ? browser.version : '')
    : false;
};

export const startTimer = (duration: number, cb: (countDown: string) => void, setNextIntervalReady: () => void) => {
  let timer = duration,
    minutes,
    seconds;
  const timerInterval = setInterval(function () {
    minutes = parseInt(`${timer / 60}`, 10);
    seconds = parseInt(`${timer % 60}`, 10);

    minutes = minutes < 10 ? `0${minutes}` : minutes;
    seconds = seconds < 10 ? `0${seconds}` : seconds;

    cb(minutes !== `00` ? `${minutes}:${seconds}` : `${seconds}`);

    if (--timer < 0) {
      clearInterval(timerInterval);
      setNextIntervalReady();
    }
  }, 1000);

  return timerInterval;
};

export const hashToArray = <T>(hash: { [key: string]: T }): Array<{ key: string; item: T }> => {
  const obj = hash ?? {};
  return Object.keys(obj).map(key => ({ key, item: obj[key] }));
};

export const removeCognitoLocalStorage = () => {
  const win = window;
  Object.keys(win.localStorage).forEach((key: string) => {
    if (key.toLowerCase().includes('cognito')) {
      win.localStorage.removeItem(key);
    }
  });
};

export const getImportOffer = (
  importData: Partial<IImportData> | null,
  intakeId: string,
  offerId: string
): IImportOffer | null => {
  return (
    importData?.offers?.find(importOffer => importOffer.intakeId === intakeId && importOffer.offerId === offerId) ??
    null
  );
};

export const getFormattedDateRange = (startDateMs?: number, endDateMs?: number): string => {
  if (!startDateMs || !endDateMs) {
    return '';
  }

  const startDate = moment(startDateMs);
  const endDate = moment(endDateMs);

  if (!startDate.isValid() || !endDate.isValid()) {
    return '';
  }

  const format1 = startDate.format('DD MMM YYYY HH:mm');
  const format2 = endDate.format('HH:mm');
  const formatTz = startDate.format('Z');

  return `${format1}-${format2} GMT${formatTz}`;
};

export const getUniLogoSrc = (): string => {
  const assetsUrl = getGlobalConfig()?.assetsUrl;
  const domain = window.location.host.split('.')[0];
  return `${assetsUrl}/branding/${domain}/images/uni_logo.png`;
};

export const headers = (idToken: string) => {
  return {
    headers: {
      Authorization: idToken,
      'Cas-Shield-Site': window.location.origin
    }
  };
};
